const WONDERPUSH_WEB_KEY = 'f188f4b43b577de44c6df288ef21898ea1ac00445d1f2a9b3ff03284c9121af6';
let initialized = false;

function pushInit() {
  window.WonderPush = window.WonderPush || [];
  // manual:true מנטרל לחלוטין את הבקשות האוטומטיות של ה-SDK (הדיאלוג שלו והחלון הנייטיבי).
  // הרשאת ההתראות נבדקת ומתבקשת במקום אחד בלבד — מסך ה-Login — לפני שמגיעים לכאן.
  window.WonderPush.push(['init', {
    webKey: WONDERPUSH_WEB_KEY,
    subscriptionDialog: { triggers: { manual: true } },
    subscriptionNative: { triggers: { manual: true } },
  }]);
  initialized = true;
}

export function initWonderPush(userId) {
  if (!userId) return;
  window.WonderPush = window.WonderPush || [];
  if (!initialized) pushInit();
  window.WonderPush.push(['setUserId', userId]);
}

export function clearWonderPush() {
  window.WonderPush = window.WonderPush || [];
  if (!initialized) {
    // ה-SDK לא אותחל בטעינה הזו (למשל כשה-cookie של הטוקן כבר נמחק, או שההרשאה לא ניתנה),
    // אבל ההתקנה בדפדפן עדיין קשורה למשתמש — לכן מאתחלים רק כדי לנתק. ה-init לעולם לא מציג דיאלוג.
    pushInit();
  }
  window.WonderPush.push(['unsetUserId']);
  // בכוונה לא מאפסים initialized: אם משתמש אחר יתחבר באותו סשן,
  // initWonderPush ידלג על init כפול ורק יריץ setUserId
}

// יוצר/משחזר את מנוי ה-push מול WonderPush. נקרא (מ-AuthProvider) רק כשהרשאת ההתראות
// כבר granted — ואז subscribeToNotifications לא פותח שום חלון.
export function ensurePushSubscription() {
  if (!initialized) return;
  window.WonderPush.push(function () {
    window.WonderPush.isSubscribedToNotifications().then(function (isSub) {
      if (!isSub) window.WonderPush.subscribeToNotifications();
    });
  });
}
